// src/components/module/compras/PurchaseOrderWrapper.tsx
// Rediseño corporativo estilo Notion/Linear
import { useParams, useLocation, useNavigate } from "react-router-dom";
import PurchaseOrderDetails from "./PurchaseOrderDetails";
import comprasApi from "../../../services/api/comprasApi";
import {
  Box,
  CircularProgress,
  Alert,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import ActionPageLayout from "../../layout/layout/ActionPageLayout/ActionPageLayout";
import { ShoppingCart as ShoppingCartIcon } from "@mui/icons-material";
import { DarkModeContext } from "../../../context/darkModeContext";
import { ICompra } from "../../types/compras.types";
import { OrderData, PurchaseOrderDetails as PurchaseOrderDetailsType } from "../../types/purchaseOrder.types";

const PurchaseOrderWrapper = () => {
  const { id } = useParams<{ id?: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const { darkMode } = useContext(DarkModeContext);

  const P = darkMode
    ? { bg: "#191919", bgS: "#202020", text: "#E8E8E6", border: "#333333", accent: "#529CCA" }
    : { bg: "#FFFFFF", bgS: "#F7F7F5", text: "#37352F", border: "#E9E9E7", accent: "#2383E2" };

  const orderDetails = location.state?.orderDetails as ICompra | undefined;
  const [isValid, setIsValid] = useState<boolean | null>(null);

  useEffect(() => {
    if (!id || !orderDetails) { setIsValid(false); return; }
    const estado = orderDetails.estadoCompra?.Nombre?.toUpperCase();
    setIsValid(estado === "ABIERTA");
  }, [id, orderDetails]);

  useEffect(() => {
    if (isValid === false) navigate("/compras", { replace: true });
  }, [isValid, navigate]);

  if (isValid === null) {
    return (
      <ActionPageLayout icon={ShoppingCartIcon} title="Cargando...">
          <Box display="flex" justifyContent="center" alignItems="center" height="200px">
            <CircularProgress size={28} sx={{ color: P.accent }} />
          </Box>
        </ActionPageLayout>
    );
  }

  if (!orderDetails || !id) {
    return (
      <ActionPageLayout icon={ShoppingCartIcon} title="Error">
          <Alert severity="error" sx={{ borderRadius: "10px" }}>
            No se pudo cargar la orden de compra.
          </Alert>
        </ActionPageLayout>
    );
  }

  const handleSave = async (details: OrderData) => {
    await comprasApi.createCompraPorArticulo({
      IdCompra: details.orden.IdCompra,
      articulosCompra: details.orden.articulosCompra.map((a) => ({
        IdArticulo: a.IdArticulo, IdSucursal: a.IdSucursal,
        CantidadComprada: a.CantidadComprada, PrecioCompra: a.PrecioCompra,
      })),
    });
    navigate("/compras");
  };

  const compatible: PurchaseOrderDetailsType = {
    IdCompra: Number(id),
    empresa: {
      Id: orderDetails.empresa?.Id ?? 0,
      Nombre: orderDetails.empresa?.Nombre ?? "Empresa",
      NIT: orderDetails.empresa?.NIT ?? "",
      Direccion: orderDetails.empresa?.Direccion ?? "",
      RepresentanteLegal: orderDetails.empresa?.RepresentanteLegal ?? "",
      Logo: orderDetails.empresa?.Logo ?? undefined,
    },
    proveedor: {
      Id: orderDetails.proveedor.Id,
      Nombre: orderDetails.proveedor.Nombre,
      NumeroIdentificacion: orderDetails.proveedor.NumeroIdentificacion,
      Direccion: orderDetails.proveedor.Direccion,
      Telefono: orderDetails.proveedor.Telefono,
      RepresentanteLegal: orderDetails.proveedor.RepresentanteLegal,
      IdTipoDocumento: orderDetails.proveedor.IdTipoDocumento ?? 1,
      Correo: orderDetails.proveedor.Correo ?? "",
      Web: orderDetails.proveedor.Web ?? "",
    },
    OrdenCompra: orderDetails.OrdenCompra,
    articulos: [], subtotal: 0, impuestos: 0, total: 0,
  };

  return (
    <ActionPageLayout icon={ShoppingCartIcon} title="Añadir artículos">
        <PurchaseOrderDetails
          idCompra={Number(id)}
          orderDetails={compatible}
          onSave={handleSave}
        />
      </ActionPageLayout>
  );
};

export default PurchaseOrderWrapper;
